
// onNavigation should be a function. On navigation, it'll be called with one argument, navigateFcn.
// If you don't want to delay the navigation, return true from onNavigation.
// If you do want to delay the navigation, return false from onNavigation.
// Later, you can call navigateFcn to proceed with the original navigation.
export default function useNavigationInterception(onNavigation) {

    RivalIQ.curation._setNativationInterceptor(onNavigation);

}
